import type { UploadedFileContentBlock } from "@/lib/chat";

/** 本文に入らずワークスペースへ置いたチャット添付。 */
export interface UploadedFile {
	/** `~/` から始まるワークスペース上のパス。 */
	path: string;
	name: string;
	byteSize: number;
}

export function uploadedFile(path: string, byteSize: number): UploadedFile {
	return { path, name: path.slice(path.lastIndexOf("/") + 1), byteSize };
}

export function toUploadedFileBlock(file: UploadedFile): UploadedFileContentBlock {
	return { type: "uploaded_file", path: file.path, size: file.byteSize };
}

export function fromUploadedFileBlock(block: UploadedFileContentBlock): UploadedFile {
	return uploadedFile(block.path, block.size);
}
